import { ApiBase } from './api-base';

export class ProxyApi extends ApiBase {
    proxy = () => this.apiClient.sendRequest({
      method: 'GET',
      url: 'proxy/Superset/login',
    });
}
